import { React, useContext } from "react";
import moment from "moment";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import "../../../components/CSS/Home/UpcomingAuditions.css";
import PostReaction from "../../../Screen/Post/PostReaction";
import { serverInfo } from "../../../App";

export default function UpcomingAuditionsContent({ post }) {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
console.log(post);
  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <div className="AudiNew mt-3">
            <center>
              <ReactPlayer
                url={videoCdnUrl + post?.video}
                playing={true}
                controls
                className="img-fluid meetImgB"
              />
            </center>

            <div className="colorAud">
              <h6 className="MeetCon-left text-light">
                {moment(post?.registration_start_date).format(
                  "LL"
                )}{" "}
                to{" "}
                {moment(post?.registration_end_date).format(
                  "LL"
                )}
              </h6>

              <div className="MeetCon-right text-center">
                <Link
                  to={`/audition/registration/${post?.event_id}`}
                  className="link-starPorfile"
                >
                  <button className="btn btn-warning text-light fw-bold bmt">
                    Registration
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div className="row  mx-4 mt-2">
            <div className="">
              <center className="d-flex justify-content-center AudiFooter border-warning p-3">
                {post.audition != null ?(<span className="carsive_font mt-2 text-warning">With : </span>):
                  (<span className="carsive_font mt-2 text-warning">{post.title} </span>)
                }

                {post.audition?.assigned_judges?.map((judge) => (
                  <span>
                    <img
                      src={imageCdnUrl + judge.user?.image}
                      alt=""
                      className="AudiPorS"
                    />
                  </span>
                ))}

              </center>
            </div>
          </div>

          <div className="my-2 Enroll-a Enroll-text">
            {post.audition?.title}
          </div>

          <PostReaction post={post} />
        </div>
      </div>
    </>
  );
}
